import React, { useState, useRef, useEffect } from 'react';
import Header from "./common/Header";
import { Link, useNavigate } from 'react-router-dom';
import {retrieveOrderLineItems, retrievePO, sendtorfms,editSoldTo,editShipTo, deleteLine, editLines, addNewLine, searchProducts,downloadDocuments, retrievePONumber, update_batch_status_and_action, compare_snapshots_and_store, retrieveAllGrandTotals, editWorkOrderNotes, retrieveWorkOrderNotes, updatePONumber} from '../api'
import { retrieveOrderItems } from '../api';
import { retrieveGrandTotal } from '../api';

import EvaluationNotify from './EvaluationNotify';

const PerformQA = () => {
	const navigate = useNavigate();
	const [productid,setproductid] = useState(null);
	const [selectedChangingRow, setSelectedChangingRow] = useState(null);
	const [selectedChangingRowIndex, setSelectedChangingRowIndex] = useState('');
	const [selectedOrderType, setSelectedOrderType] = useState(null);
	const [products, setProducts] = React.useState([]);
const [selectedProduct, setSelectedProduct] = React.useState(null);
const [selectedProductId, setSelectedProductId] = useState(null);
const [selectedStyleNumber, setSelectedStyleNumber] = useState("");
const [selectedColorId, setSelectedColorId] = useState(null);
const [selectedColIndex, setSelectedColIndex] = React.useState(null);
const [searchValue, setSearchValue] = useState("");
const [loading, setLoading] = useState(true);


useEffect(() => {
  if (selectedChangingRow?.styleName) {
    setSearchValue(`${selectedChangingRow.styleName} | ${selectedChangingRow.styleNumber}`);
  }
}, [selectedChangingRow]);

const handleChange = (e) => {
  setSearchValue(e.target.value);
};
const handleProductSelect = (product) => {

    setSelectedProduct(product);
};

	const states = [
		"Alabama",
		"Alaska",
		"Arizona",
		"Arkansas",
		"California",
		"Colorado",
		"Connecticut",
		"Delaware",
		"Florida",
		"Georgia",
		"Hawaii",
		"Idaho",
		"Illinois",
		"Indiana",
		"Iowa",
		"Kansas",
		"Kentucky",
		"Louisiana",
		"Maine",
		"Maryland",
		"Massachusetts",
		"Michigan",
		"Minnesota",
		"Mississippi",
		"Missouri",
		"Montana",
		"Nebraska",
		"Nevada",
		"New Hampshire",
		"New Jersey",
		"New Mexico",
		"New York",
		"North Carolina",
		"North Dakota",
		"Ohio",
		"Oklahoma",
		"Oregon",
		"Pennsylvania",
		"Rhode Island",
		"South Carolina",
		"South Dakota",
		"Tennessee",
		"Texas",
		"Utah",
		"Vermont",
		"Virginia",
		"Washington",
		"West Virginia",
		"Wisconsin",
		"Wyoming",
	  ];
	  
	  const cities = {
		Alabama: ["Birmingham", "Montgomery", "Mobile"],
		Alaska: ["Anchorage", "Fairbanks", "Juneau"],
		Arizona: ["Phoenix", "Tucson", "Mesa"],
		Arkansas: ["Little Rock", "Fort Smith", "Fayetteville"],
		California: ["Los Angeles", "San Francisco", "San Diego"],
		Colorado: ["Denver", "Colorado Springs", "Aurora"],
		Phoenix: ["Maricopa"],
		// ... Add other states and cities
		Wyoming: ["Cheyenne", "Casper", "Laramie"],
	  };
	  
	  const counties = {
		Alabama: ["Jefferson", "Mobile", "Madison"],
		Alaska: ["Anchorage Municipality", "Fairbanks North Star Borough"],
		Arizona: ["Maricopa", "Pima", "Yuma"],
		Arkansas: ["Pulaski", "Benton", "Washington"],
		California: ["Los Angeles", "San Diego", "Orange"],
		Colorado: ["Denver", "El Paso", "Arapahoe"],
		// ... Add other states and counties
		Wyoming: ["Laramie", "Natrona", "Sweetwater"],
	  };

	const [ShipTo, setShipTo] = useState({
		firstName: "",
		lastName: "",
		address1: "",
		address2: "",
		state: "",
		city: "",
		postalCode: "",
		county: "",
	});
	const [SoldTo, setSoldTo] = useState({
		customerID: "",
		customerTYpe: "",
		firstName: "",
		lastName: "",
		email: "",
		phone1: "",
		salesman1: "",
		state: "",
		city: "",
		county: "",
	});
	const [poNumber, setPoNumber] = useState(null);
	const [expandedRows, setExpandedRows] = useState({});
	const [expandedRowKey, setExpandedRowKey] = useState({});
	const toggleRow = (key) => {
		setExpandedRowKey(key)
		setExpandedRows((prev) => ({
		  ...prev,
		  [key]: !prev[key],
		}));
	  };

	
	  
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setShipTo({ ...ShipTo, [name]: value });
	};
	const handleInputChangeRow = (e) => {
		const updatedValue = e.target.value;
	  
		if (updatedValue.includes(" | ")) {
		  const [newStyleName, newStyleNumber] = updatedValue.split(" | ");
	  
		  setSelectedChangingRow((prevRow) => ({
			...prevRow,
			styleName: newStyleName || "", // Ensure empty if deleted
			styleNumber: newStyleNumber !== undefined ? newStyleNumber : "", // Ensure "undefined" if missing
		  }));
		} else {
		  // If " | " is removed, clear the styleNumber but allow retyping
		  setSelectedChangingRow((prevRow) => ({
			...prevRow,
			styleName: updatedValue.trim(),
			styleNumber: "", // Ensure "undefined" is shown
		  }));
		}
	  };
	  
	  
	  

	const getCities = () => cities[ShipTo.state] || [];
	const getCounties = () => counties[ShipTo.state] || [];

	const handleShipToSubmit = (e) => {
		e.preventDefault();
		const updatedShipToValue = `${ShipTo.firstName} ${ShipTo.lastName}, ${ShipTo.address1}, ${ShipTo.address2 || ""}, ${ShipTo.state}, ${ShipTo.city}, ${ShipTo.postalCode}, \n${ShipTo.county}`;
		setShipToValue(updatedShipToValue);
		setenableValidate(false);
		
		setShowShipping(false);
	};
	const handleSoldToSubmit = (e) => {
		e.preventDefault();
		// Construct the SoldTo value string using the initialized SoldTo object
		const updatedSoldToValue = `${SoldTo.customerID}, ${SoldTo.customerTYpe}, ${SoldTo.firstName} ${SoldTo.lastName}, ${SoldTo.postalCode || ""}, ${SoldTo.state}, ${SoldTo.city}, ${SoldTo.county}, ${SoldTo.phone1 || ""}, ${SoldTo.email || ""}, ${SoldTo.salesman1 || ""}`;

		// Update state and UI after submission
		setSoldToValue(updatedSoldToValue);
		setenableValidate(false);
		setShowSold(false);
	};
	

	const shipingInputChange = (e) => {
		const { name, value } = e.target;
		setShipTo({ ...ShipTo, [name]: value });
	};
	const soldInputChange = (e) => {
		const { name, value } = e.target;
		// For salesman1 field, if it's empty, set it to empty string
		const finalValue = (name === 'salesman1' && (!value || value.trim() === '')) ? '' : value;
		setSoldTo({ ...SoldTo, [name]: finalValue });
	};

	const getSoldCities = () => cities[ShipTo.state] || [];
	const getSoldCounties = () => counties[ShipTo.state] || [];

	const soldSubmit = (e) => {
		e.preventDefault();
	};
	const [data, setData] = useState([]);
	const [enableValidate, setenableValidate] = useState(true);
	const [linesData, setLinesData] = useState([]);
	const [rowNotesState, setRowNotesState] = useState({});
	const [workOrderNotes, setWorkOrderNotes] = useState({});
	const [colorNames,setcolornames] = useState([]);
	const [selectedColor, setSelectedColor] = useState('');
	const [rows, setRows] = useState([]);
	const [batchName, setBatchName] = useState('');
	const [builderName, setBuilderName] = useState('');
	const [isQASearch, setQASearch] = useState(false);
	const [showloader,setshowloader] = useState(false);
	const [poNumbers,setPoNumbers] = useState([]);
	useEffect(() => {
		const fetchOrderItems = async () => {
			try {
				const url = new URL(window.location.href);
				const params = new URLSearchParams(url.search);
				const name = params.get('batch_name'); 
				const builder = params.get('builder_name');
				// Fetch PO Number
				const po_number = await retrievePO(name);

				setPoNumber(po_number);
				setBatchName(name);
				setBuilderName(builder);

				// Fetch order items
				const orderItems = await retrieveOrderItems(name, po_number.PoNumber);
				// Fetch line items
				const lines_data = await retrieveOrderLineItems(name, po_number.PoNumber);

				await update_batch_status_and_action(name)
				setLinesData(JSON.parse(lines_data));

				// Load existing work order notes using the new API
				try {
					const workOrderNotesResponse = await retrieveWorkOrderNotes(name);
					if (workOrderNotesResponse && workOrderNotesResponse.workOrderNotes) {
						setWorkOrderNotes(workOrderNotesResponse.workOrderNotes);
						
						// Automatically show notes sections for order types that have notes
						const notesToShow = {};
						Object.keys(workOrderNotesResponse.workOrderNotes).forEach(orderType => {
							const notes = workOrderNotesResponse.workOrderNotes[orderType];
							if (notes && notes.trim() !== '') {
								notesToShow[orderType] = true;
							}
						});
						setRowNotesState(notesToShow);
					}
				} catch (error) {
					console.error("Error loading work order notes:", error);
				}

				// Use the first order for other data (ShipTo, SoldTo, etc.)
				const data = orderItems[0];

				// Fetch additional PO numbers
				const po_numbers = await retrievePONumber(data.shipTo.address1, ".");
				setPoNumbers(po_numbers);
				// ShipTo & SoldTo Details
				setShipToValue(`${data.shipTo.firstName} ${data.shipTo.lastName}, ${data.shipTo.address1},${data.shipTo.address2},${data.shipTo.state},${data.shipTo.city},${data.shipTo.postalCode},${data.shipTo.county}`);
				setSoldToValue(`${data.soldTo.customerId},${data.soldTo.customerType},${data.soldTo.firstName} ${data.soldTo.lastName}, ${data.soldTo.postalCode},${data.soldTo.state},${data.soldTo.city},${data.soldTo.county},${data.soldTo.phone1 || ""},${data.soldTo.email || ""},${data.soldTo.salesman1 || ""}`);

				// Backup values
				oldsetShipTo(`${data.shipTo.firstName} ${data.shipTo.lastName}, ${data.shipTo.address1},${data.shipTo.address2},${data.shipTo.state},${data.shipTo.city},${data.shipTo.postalCode},${data.shipTo.county}`);
				oldsetSoldTo(`${data.soldTo.customerId},${data.soldTo.customerType},${data.soldTo.firstName} ${data.soldTo.lastName}, ${data.soldTo.postalCode},${data.soldTo.state},${data.soldTo.city},${data.soldTo.county},${data.soldTo.phone1 || ""},${data.soldTo.email || ""},${data.soldTo.salesman1 || ""}`);

				// Set structured state
				setShipTo({
					firstName: data.shipTo.firstName,
					lastName: data.shipTo.lastName,
					address1: data.shipTo.address1,
					address2: data.shipTo.address2,
					state: data.shipTo.state,
					city: data.shipTo.city,
					postalCode: data.shipTo.postalCode,
					county: data.shipTo.county,
				});

				setSoldTo({
					customerID: data.soldTo.customerId,
					customerTYpe: data.soldTo.customerType,
					firstName: data.soldTo.firstName,
					lastName: data.soldTo.lastName,
					postalCode: data.soldTo.postalCode,
					state: data.soldTo.state,
					city: data.soldTo.city,
					county: data.soldTo.county,
					phone1: data.soldTo.phone1 || "",
					email: data.soldTo.email || "",
					salesman1: data.soldTo.salesman1 || "",
				});

				// Transform data for table
				const transformedData = data.lines.map((line, index) => ({
					id: index + 1,
					description: line.styleName || "No Style Name",
					notes: line.workOrderLines.flatMap(workOrder => workOrder.notes).flat() || "",
					color: line.colorName || "-",
					qty: line.quantity || 0,
					price: line.unitPrice || 0,
					totalprice: (line.billQuantity || 0) * (line.unitPrice || 0),
					isEditing: false,
					units: line.unit || "Unknown",
				}));

				setRows(transformedData);
			} catch (error) {
				console.error('Error fetching order items:', error);
			} finally {
				setLoading(false);  // stop loading after fetch (success or fail)
			}
		};

		fetchOrderItems();
	}, [batchName]);

	// Separate useEffect for grand total
	useEffect(() => {
		const fetchGrandTotal = async () => {
			try {
				if (!batchName || !poNumber?.poNumber) {
					return;
				}
				const response = await retrieveGrandTotal(batchName, poNumber.poNumber);
				setGrandTotal(response.grandTotal || 0);
			} catch (error) {
				console.error('Error fetching grand total:', error);
				setGrandTotal(0);
			}
		};

		// Only fetch grand total if we have both batchName and poNumber
		if (batchName && poNumber?.poNumber) {
			fetchGrandTotal();
		}
	}, [batchName, poNumber]);

	// Log state updates correctly
	useEffect(() => {
	}, [poNumbers]);
	
    useEffect(() => {

        if (products.length === 1) {
            const onlyProd = products[0];
            setSelectedProduct(onlyProd.styleName);
            setSelectedProductId(onlyProd.id);
            setSelectedStyleNumber(onlyProd.styleNumber || "");
            setcolornames(onlyProd.colorOptions.map(color => color.colorName));
            const colors = onlyProd.colorOptions.map(color => color.colorName);
            setcolornames(colors);
            // Automatically select the only color available
            if (colors.length === 1) {
                // alert('Product Length is 1 and colors length is 1')
                setSelectedColor(colors[0]);
                setProductSelected(true);
                setColorSelected(colors[0]);
                try {
                    const colorObj = (onlyProd.colorOptions || []).find(c => String(c.colorName) === String(colors[0]));
                    if (colorObj) {
                        setSelectedColorId(colorObj.id);
                    }
                } catch (e) {}
            }
            else if (colors.length === 0) {
                setTimeout(() => setcolornames([...new Set([])]), 0);
                setProductSelected(true);
                
            }
        }
        else if (products.length > 1)
        {
            if (selectedColIndex == 2){
                const selectedProductLocal = products.find((product) => product.styleName === productName);
                if (selectedProductLocal) {
                // Set colorNames from the selected product's colorOptions
                setcolornames(selectedProductLocal.colorOptions.map((color) => color.colorName));
                
                // Ensure selectedProduct is set
                setSelectedProduct(productName);
                setSelectedColor(selectedChangingRow.colorName);
                setSelectedProductId(selectedProductLocal.id);
                setSelectedStyleNumber(selectedProductLocal.styleNumber || "");
            }
            
            }
        }
        else {
            setProductSelected(false)
        }
    }, [products]);
	useEffect(() => {
        if (colorNames.length === 1) {
            // alert('Color Length is 1')
			// alert(colorNames[0])
            setcolornames(colorNames);
			setProductSelected(true);
        }
		// else if (colorNames.length === 0) {
        //     // alert('Color Length is 1')
		// 	// alert(colorNames[0])
		// 	// alert('Change No COlor')
		// 	setcolornames([]);
		
        // }
    }, [products]);
// Add a new useEffect to log changes in poNumber
useEffect(() => {
    if (poNumber) {
    }
}, [poNumber]);
useEffect(() => {
}, [poNumbers]);

	useEffect(() => {
	// if (colorNames.length === 0)
	// {
	// 	// setcolornames(['-'])
	// }
}, [colorNames]);

	useEffect(() => {
	}, [workOrderNotes]);
	const addRow = (orderType,index) => {
		// Create a new empty row
		const newRow = {
			id: `row-${orderType}-${index}`,
			description: "",
			color: "",
			styleName: "",
			styleNumber: "",
			colorName: "",
			productId: "",
			colorId: "",
			quantity: 0,
			unitPrice: 0,
			billQuantity: 0,
			unit: "",
			workOrderLines: {
				notes: [],
			},
			warnings:{quantity: ['warnings: Quantity is zero or negative'], styleName: ['warnings: Could not find product'], color_name: ['No Color'],unitPrice:[0], notes: []},
		};
		addNewLine(
			index,
			batchName,
			poNumber.PoNumber,
			orderType,
			newRow.productId,
			newRow.colorId,
			newRow.unitPrice,
			newRow.styleName,
			newRow.colorName,
			newRow.billQuantity,
			newRow.styleNumber,
			newRow.unit
		);

		// Insert the row into the specific orderType in linesData
		setLinesData((prevLinesData) => {
			const updatedLinesData = { ...prevLinesData };

			// Initialize the array for the given orderType if it doesn't exist
			if (!updatedLinesData[orderType]) {
				updatedLinesData[orderType] = [];
			}

			// Ensure we're pushing only one row
			updatedLinesData[orderType] = [...updatedLinesData[orderType], newRow];
			setTimeout(() => {
				const newRowElement = document.getElementById(newRow.id);
				if (newRowElement) {
					newRowElement.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			}, 200);

			return updatedLinesData;
		});
	};
	
	  
	  
	
	function fetchAllRowsData(linesData, allRowsData) {
		Object.keys(linesData).forEach((key) => { // 'key' is the orderType
		  if (Array.isArray(linesData[key]) && linesData[key].length > 0) {
			linesData[key].forEach((row, subIndex) => { // 'subIndex' is the line number
			  // Safely handle colorName - check for null/undefined before calling trim
			  let colorName = '';
			  if (row.colorName && typeof row.colorName === 'string') {
				colorName = row.colorName.trim();
			  }
	  
			  // Safely handle styleName - check for null/undefined before calling trim
			  if (!colorName && row.styleName && typeof row.styleName === 'string' && row.styleName.trim()) {
				colorName = '-'; // If colorName is empty but styleName is present, set to '-'
			  }
	  
			  // Handle notes properly - check for different possible formats
			  let notes = '';
			  if (row.workOrderLines?.notes) {
				if (Array.isArray(row.workOrderLines.notes)) {
				  // If it's an array, join with commas
				  notes = row.workOrderLines.notes.join(', ');
				} else if (typeof row.workOrderLines.notes === 'string') {
				  // If it's already a string, use it directly
				  notes = row.workOrderLines.notes;
				} else if (row.workOrderLines.notes && row.workOrderLines.notes.length > 0) {
				  // If it has length but isn't an array, try to convert
				  notes = String(row.workOrderLines.notes);
				}
				// Only use empty string if notes is empty, null, or undefined
				if (!notes || (typeof notes === 'string' && notes.trim() === '')) {
				  notes = '';
				}
			  }
	  
			  allRowsData.push({
				orderType: key, // 'key' is the orderType from the loop
				lineNumber: subIndex, 
				styleName: row.styleName || '',
				colorName: colorName,
				quantity: row.quantity || 0,
				unitPrice: row.unitPrice || 0,
				price: row.price || 0,
				unit: row.unit || '', // Add the unit field
				notes: notes,
				productId: row.productId || '',
				colorId: row.colorId || '',
				isEditing: false,
			  });
			});
		  }
		});
	  }
	  
	  
	
	const [isEMS, setEMS] = useState(false);
	const [isValidating, setValidating] = useState(false);
	const [isInvalid, setInvalid] = useState(false);
	const [isNotesComple, setNotesComple] = useState(false);
	
	const [isShipEditable, setIsShipEditable] = useState(false);
	const [isSoldEditable, setIsSoldEditable] = useState(false);
	const [progress, setProgress] = useState(0);
	const [showPopup, setShowPopup] = useState(false);
	const [rowToDelete, setRowToDelete] = useState(null);
	const [showSuccessPopup, setShowSuccessPopup] = useState(false);
	const [showErrorPopup, setShowErrorPopup] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const [isSendingToRFMS, setIsSendingToRFMS] = useState(false);
	const [rfmsProgress, setRfmsProgress] = useState(0);
	const [ShowShipping, setShowShipping] = useState(null);
	const [ShowSold, setShowSold] = useState(null);
	const [orderType2024, setOrderType2024] = useState([]);
	const [PeformQAState, setPeformQAState] = useState(null);
	const [isProductSelected, setProductSelected] = useState(false);
	const [ColorSelected, setColorSelected] = useState(false);
const closeSearchPopup = () => {
		setProducts([]); // Clear products list
		setSelectedProduct(null); // Clear selected product
		setSearchValue(''); // Clear search input
		setProductName(''); // Clear product name
		setSelectedColor(''); // Clear selected color
		setColorSelected([]); // Clear color options
		setSelectedChangingRow({}); // Reset selected row values
		setSelectedProductId(null);
		setSelectedStyleNumber("");
		setSelectedColorId(null);
	
		setQASearch(false);
	};
	
const chooseProduct = () => {
		if (!selectedOrderType || selectedChangingRowIndex === '') {
			console.error('No row selected for update');
			return;
		}

		const updatedFields = {
			styleName: selectedProduct,
			styleNumber: selectedStyleNumber,
			colorName: ColorSelected,
			productId: selectedProductId,
			colorId: selectedColorId
		}
		
		const updatedArray = [...linesData[selectedOrderType]];
		updatedArray[selectedChangingRowIndex] = {
			...updatedArray[selectedChangingRowIndex],
			...updatedFields,
		};
		setLinesData({
			...linesData,
			[selectedOrderType]: updatedArray,
		});

		// Update the popup current values immediately
		setSelectedChangingRow((prev) => ({
			...prev,
			...updatedFields,
		}));
		setProductName(selectedProduct || '');

		setProductSelected(false);
		setQASearch(false);
		setenableValidate(false);
	}
	const anyProductSelect = () =>{
		setProductSelected(true);
	};
	const handleDeleteClick = (index,key) => {
		var orderType = key;
		setOrderType2024(orderType);
		setRowToDelete(index);
		setShowPopup(true); 		
	};
	const toggleNotesBox = (key) => {
		setRowNotesState((prev) => ({
		  ...prev,
		  [key]: !prev[key], // Toggle the state for the specific row
		}));
		// Wait for the state update before scrolling
		setTimeout(() => {
			const notesElement = document.getElementById(`notes-${key}`);
			if (notesElement) {
				notesElement.scrollIntoView({ behavior: "smooth", block: "center" });
			}
		}, 100);
	  };

	const confirmDelete = () => {
		// Ensure that the rowToDelete and orderType2024 are correctly defined
		if (orderType2024 && rowToDelete !== null) {
			setLinesData((prevLinesData) => {
				const updatedLinesData = { ...prevLinesData };
	
				// Check if the orderType exists in the linesData
				if (updatedLinesData[orderType2024] && Array.isArray(updatedLinesData[orderType2024])) {
					// Filter out the row at the specified index
					updatedLinesData[orderType2024] = updatedLinesData[orderType2024].filter((_, i) => i !== rowToDelete);
				}
				return updatedLinesData;
			});
	
			// Call deleteLine function to remove from the server/database or any other necessary action
			deleteLine(rowToDelete, batchName, poNumber.PoNumber, orderType2024);
	
			// Close the popup and reset other states
			setShowPopup(false);  // Close the confirmation popup
			setRowToDelete(null);  // Reset the rowToDelete
			setenableValidate(false);  // Optionally reset the validation state
		}
	};
	

	const cancelDelete = () => {
		setShowPopup(false); // Close the popup without deleting
		setRowToDelete(null);
	};
	
	const closeSuccessPopup = () => {
		setShowSuccessPopup(false);
		setSuccessMessage('');
		navigate('/orders-lisiting'); // Navigate to orders listing page after success
	};
	
	const closeErrorPopup = () => {
		setShowErrorPopup(false);
		setErrorMessage('');
		// Stay on the same page when error occurs
	};
	const OpenQASearch = async (styleName) => {
		setQASearch(true);
		setProducts([]);
		

		setSelectedProduct(null)
		// document.querySelector("#po2rfms-qasearch").submit();
		const productDescription = styleName;
		const result = await searchProducts(productDescription); // Call API
		
		setProducts(result); // Save results to state
		setKeywords(result)
		setshowloader(false)
		setProductSelected(false);

	}
	const [shipToValue, setShipToValue] = useState(
		""
	);
	const [productName, setProductName] = useState(
		""
	);

	const handleDoubleClick = (row, index, col_index, orderType) => {
		setProducts([]); // Clear products list
		setSelectedProduct(null); // Clear selected product
		setSearchValue(''); // Clear search input
		setProductName(''); // Clear product name
		setSelectedColor(''); // Clear selected color
		setColorSelected([]); // Clear color options
		setSelectedChangingRow({}); // Reset selected row values
		setSelectedColIndex(col_index)
		setSelectedOrderType(orderType); // Store the order type
		setproductid(row.productId)
		setSelectedChangingRow(row); // Save the clicked row
		setSelectedChangingRowIndex(index); // Save the clicked row
		setProductName(row.styleName)
		setshowloader(true);
		
		OpenQASearch(row.styleName);
	};
	
	  useEffect(() => {
		if (selectedChangingRow) {
		  setproductid(selectedChangingRow.productId)
		}
	  }, [selectedChangingRow]);
	const setKeywords = (result) => {
		const productid = document.getElementById('productid').value;

		// const product = products.find(p => p.id === productid);
		const productidParsed = Number(productid); // Try converting productid to a number

		// Find product using both string and number comparison (type conversion)
		const product = result.find(p => {
		return (Number(p.id) === productidParsed) || (String(p.id) === productid);
		});

		// If product is found, get styleName and styleNumber
		if (product) {
		const { styleName, styleNumber } = product;
		// document.querySelector('input[name="productSearch"]').value = `${styleName} | ${styleNumber}`;
		setSelectedChangingRow((prevRow) => ({
			...prevRow,
			styleName: styleName || "", // Ensure empty if deleted
			styleNumber: styleNumber , // Ensure "undefined" if missing
		}));
		
		} else {
		}


	};


	const [soldToValue, setSoldToValue] = useState(
		``
	);

	const [oldShipTo, oldsetShipTo] = useState(
		``
	);

	const [oldSoldTo, oldsetSoldTo] = useState(
		``
	);

	const shipToRef = useRef(null);
	const soldToRef = useRef(null);

	const toggleShipEditable = () => {
		setShowShipping(true)
	};

	const toggleSoldEditable = () => {
		setShowSold(true)

	};
	const cancelShiping = () => {

		setShowShipping(false);
	}
	const cancelSold = () => {

		setShowSold(false);
	}
	const hideSelectedNote = async (key) => {
		// Clear the work order notes from state
		setWorkOrderNotes((prev) => ({
			...prev,
			[key]: '',
		}));
		
		// Hide the notes section
		setRowNotesState((prev) => ({
			...prev,
			[key]: false, // Hide the note for the specific row
		}));
		
		// Clear the notes from the backend
		try {
			// Find the PO number for this order type
			const poEntry = poNumbers.find(item => item.startsWith(`${key}:`));
			if (poEntry) {
				const poValue = poEntry.split(':')[1];
				await editWorkOrderNotes(poValue, key, '');
			}
		} catch (error) {
			console.error(`Error clearing work order notes for ${key}:`, error);
		}
	};

	const handleWorkOrderNotesChange = (key, value) => {
		setWorkOrderNotes((prev) => ({
			...prev,
			[key]: value,
		}));
		setenableValidate(false);
	};


	const showSelectedNote = (key) => {
		setExpandedRows((prev) => ({
		  ...prev,
		  [key]: !prev[key], // Toggle visibility for the specific row
		}));
	  };
	const handleFocus = (e) => {
		const input = e.target;

		// Remove readonly on double-click
		if (input.readOnly) {
			input.readOnly = false; // Allow editing
		}

		// Move cursor to the end of the input
		const length = input.value.length;
	};

	const handleBlur = (e) => {
		const input = e.target;

		// Reapply readonly on focus out
		input.readOnly = true;
	};
	const triggerValidateChanges = async () => {
		setValidating(true); // Start progress bar
		setProgress(10); // Start progress at 10% to show activity
	
		try {
			// ShipTo update (synchronous)
			editShipTo(
				ShipTo.address1,
				ShipTo.firstName,
				ShipTo.lastName,
				ShipTo.address1,
				ShipTo.address2,
				ShipTo.state,
				ShipTo.city,
				ShipTo.postalCode,
				ShipTo.county
			);
			// Fetch all rows data
			const allRowsData = [];
			fetchAllRowsData(linesData, allRowsData);

			// Prepare work order notes updates
			const workOrderNotesUpdates = [];
			Object.keys(workOrderNotes).forEach(orderType => {
				if (workOrderNotes[orderType] && workOrderNotes[orderType].trim()) {
					// Find the PO number for this order type
					const poEntry = poNumbers.find(item => item.startsWith(`${orderType}:`));
					if (poEntry) {
						const poValue = poEntry.split(':')[1];
						workOrderNotesUpdates.push(
							editWorkOrderNotes(poValue, orderType, workOrderNotes[orderType])
								.then(response => {
								})
								.catch(error => {
									console.error(`Work order notes update failed for ${orderType}:`, error);
								})
						);
					}
				}
			});

			// Run async API calls in parallel
			await Promise.all([
				editSoldTo(
					ShipTo.address1,
					SoldTo.customerID,
					SoldTo.customerTYpe,
					SoldTo.firstName,
					SoldTo.lastName,
					SoldTo.postalCode,
					SoldTo.state,
					SoldTo.city,
					SoldTo.county,
					SoldTo.email,
					SoldTo.phone1,
					SoldTo.salesman1 || ""
				)
					.then(response => {
					})
					.catch(error => {
						console.error("SoldTo update failed:", error);
					}),
				await editLines(allRowsData, batchName, poNumber.PoNumber)
					.then(response => {
					})
					.catch(error => {
						console.error("Lines update failed:", error);
					}),
				await compare_snapshots_and_store(batchName),
				...workOrderNotesUpdates
			]);
	
		} catch (error) {
			console.error("Error during updates:", error);
		} finally {
			setProgress(100); // Ensure progress hits 100% once everything is done
			setTimeout(() => setValidating(false), 500); // Small delay before hiding
		}
	};
	
	const handleUpdatePONumber = async () => {
		try {
			// Generate a random 8-digit number
			const newPoNumber = Math.floor(10000000 + Math.random() * 90000000).toString();
			
			// Call the API to update PO number
			const response = await updatePONumber(batchName, newPoNumber);
			// Refresh the page to show the updated PO number
			window.location.reload();
			
		} catch (error) {
			console.error("Error updating PO number:", error);
			alert("Failed to update PO number. Please try again.");
		}
	};
	
	

const handleColorClick = (e) => {
    const colorNameLocal = e.target.value;
    setProductSelected(true);
    setColorSelected(colorNameLocal);
    setSelectedColor(colorNameLocal);
    // derive colorId from selected product
    try {
        const prod = products.find(p => String(p.id) === String(selectedProductId));
        if (prod && Array.isArray(prod.colorOptions)) {
            const colorObj = prod.colorOptions.find(c => String(c.colorName) === String(colorNameLocal));
            if (colorObj) {
                setSelectedColorId(colorObj.id);
                // reflect in current values
                setSelectedChangingRow((prev) => ({
                    ...prev,
                    colorName: colorNameLocal,
                    colorId: colorObj.id
                }));
            }
        }
    } catch (err) {
        // ignore
    }
};

const handleLabelClick = (e,products) => {
    const productStyleName = e.target.value;
    const product_index = e.target.selectedIndex;
    let selectedProductObj = null;
    if(products.length > 1){
        selectedProductObj = products[product_index-1];
    }
    else if(products.length == 1){
        selectedProductObj = products[product_index];
    }

    if(selectedProductObj && selectedProductObj.colorOptions.length === 0)
    {
        setProductSelected(true);
    }

    if (selectedProductObj && Array.isArray(selectedProductObj.colorOptions)) {
        selectedProductObj.colorOptions.forEach((color, index) => {
        });
        const colorNamesLocal = selectedProductObj.colorOptions.map(color => color.colorName);
        setcolornames(colorNamesLocal); 
    } else {
        setcolornames([]);
    }

    setSelectedProduct(productStyleName);
    setProductName(productStyleName);
    if (selectedProductObj) {
        setSelectedProductId(selectedProductObj.id);
        setSelectedStyleNumber(selectedProductObj.styleNumber || "");
        // if single color, set color id too
        if (selectedProductObj.colorOptions && selectedProductObj.colorOptions.length === 1) {
            setSelectedColorId(selectedProductObj.colorOptions[0].id);
        } else {
            setSelectedColorId(null);
        }
        // reflect product id change in current values
        setSelectedChangingRow((prev) => ({
            ...prev,
            productId: selectedProductObj.id
        }));
    }
		// Remove the class from all siblings
		const parent = e.target.parentNode;
		Array.from(parent.children).forEach((child) =>
		  child.classList.remove("po2rfms-selected")
		);
	
		// Add the class to the clicked element
    const el = e.target;
		if (el) {
		  el.classList.add("po2rfms-selected");
		}
	  };
	const triggerEMS = (e) => {
		e.preventDefault();
		setEMS(true);
	};
	const closeRMS = (e) => {
		setEMS(false);
	}
	function compareStrings(str1, str2) {
		const arr1 = (typeof str1 === 'string' ? str1 : "").split(',').map(s => s.trim());
		const arr2 = (typeof str2 === 'string' ? str2 : "").split(',').map(s => s.trim());
		
	
		if (arr1.length !== arr2.length) {
			return 0;
		}
	
		let differences = [];
	
		arr1.forEach((item, index) => {
			if (item !== arr2[index]) {
				differences.push({ position: index + 1, value1: item, value2: arr2[index] });
			}
		});
	
		if (differences.length === 0) {
			return 0;
		} else {
			return differences.length
			
		}
	}

	const handlesendtorfms = async (shipToValue,soldToValue,batchName) => {
		try {
			// Start loader
			setIsSendingToRFMS(true);
			setRfmsProgress(10);
			
			var total_differences = 0;
			// const sentorfms = await sendtorfms(shipToValue,soldToValue,oldShipTo,oldSoldTo);
			const oldupdatedSoldToValue = (typeof oldSoldTo === 'object' && oldSoldTo !== null)
			? `${oldSoldTo.customerID || ""}, ${oldSoldTo.customerTYpe || ""}, ${oldSoldTo.firstName || ""}, ${oldSoldTo.lastName || ""}, ${oldSoldTo.email || ""}, ${oldSoldTo.phone1 || ""}, ${oldSoldTo.city || ""}, ${oldSoldTo.county || ""}, ${oldSoldTo.state || ""}`
			: oldSoldTo;
			const oldupdatedShipToValue = (typeof oldShipTo === 'object' && oldShipTo !== null)
			? `${oldShipTo.firstName || ""}, ${oldShipTo.lastName || ""}, ${oldShipTo.email || "N/A"}, ${oldShipTo.address1 || ""}, ${oldShipTo.address2 || ""}, ${oldShipTo.city || ""}, ${oldShipTo.state || ""}, ${oldShipTo.county || ""}, \n${oldShipTo.postalCode || ""}`
			: oldShipTo;
			total_differences += compareStrings(shipToValue, oldupdatedShipToValue);
			// Compare SoldTo and oldSoldTo
			total_differences += compareStrings(soldToValue, oldupdatedSoldToValue);

			// The loader will keep animating while waiting for response
			const sentorfms = await sendtorfms(
				batchName ,
				builderName,
				total_differences
			);
			// Show success popup with the message from backend
			setSuccessMessage(sentorfms.message || 'Successfully sent to RFMS');
			setShowSuccessPopup(true);
		} catch (error) {
			console.error('Error sending to RFMS:', error);
			// Extract error message from the error object
			let errorMsg = 'Failed to send to RFMS';
			if (error.message) {
				errorMsg = error.message;
			}
			setErrorMessage(errorMsg);
			setShowErrorPopup(true);
		} finally {
			// Complete the progress and hide loader
			setRfmsProgress(100);
			setTimeout(() => {
				setIsSendingToRFMS(false);
				setRfmsProgress(0);
			}, 500);
		}
	}
	useEffect(() => {
		if (isValidating) {
			setProgress(10); // Start progress at 10%
	
			let progressInterval = setInterval(() => {
				setProgress((prev) => {
					if (prev >= 90) return prev; // Stop auto-increasing after 90%
					return prev + 1.5; // Increment progress smoothly
				});
			}, 500); // Adjust speed here (500ms per step)
	
			return () => clearInterval(progressInterval); // Cleanup
		}
	}, [isValidating]);
	
	// Progress animation for RFMS sending
	useEffect(() => {
		if (isSendingToRFMS) {
			let progressInterval = setInterval(() => {
				setRfmsProgress((prev) => {
					if (prev >= 90) return prev; // Stop auto-increasing after 90%
					return prev + 2; // Increment progress smoothly
				});
			}, 300); // Faster animation for RFMS
	
			return () => clearInterval(progressInterval); // Cleanup
		}
	}, [isSendingToRFMS]);
	const [grandTotal, setGrandTotal] = useState(0);
	const [calculatedTotal, setCalculatedTotal] = useState(0);

	useEffect(() => {
		const calculateTotal = () => {
			let total = 0;
			Object.values(linesData).forEach(orderTypeLines => {
				orderTypeLines.forEach(row => {
					if (Number(row.quantity) > 0 && Number(row.unitPrice) > 0) {
						total += Number(row.quantity) * Number(row.unitPrice);
					}
				});
			});
			setCalculatedTotal(total);
		};
		calculateTotal();
	}, [linesData]);

	useEffect(() => {
		const fetchGrandTotal = async () => {
			try {
				if (!batchName || !poNumber?.poNumber) {
					return;
				}
				const response = await retrieveGrandTotal(batchName, poNumber.poNumber);
				setGrandTotal(response.grandTotal || 0);
			} catch (error) {
				console.error('Error fetching grand total:', error);
				setGrandTotal(0);
			}
		};
		fetchGrandTotal();
	}, [batchName, poNumber]);

	// Add a separate useEffect to log PO number changes
	useEffect(() => {
	}, [poNumber]);

	// Add a new state for storing grand totals by order type
	const [grandTotalsByOrderType, setGrandTotalsByOrderType] = useState({});

	// Add a new useEffect to fetch grand totals for each order type
	useEffect(() => {
		const fetchGrandTotals = async () => {
			if (!batchName || !poNumbers.length) return;

			try {
				// Extract just the PO numbers from the poNumbers array
				const poNumberList = poNumbers.map(item => item.split(':')[1]).join(',');
				
				const response = await retrieveAllGrandTotals(batchName, poNumberList);
				
				// Create a mapping of order types to grand totals
				const newGrandTotals = {};
				poNumbers.forEach(item => {
					const [orderType, poNumber] = item.split(':');
					newGrandTotals[orderType] = response.grandTotals[poNumber] || 0;
				});
				
				setGrandTotalsByOrderType(newGrandTotals);
			} catch (error) {
				console.error('Error fetching all grand totals:', error);
				// Set all grand totals to 0 in case of error
				const newGrandTotals = {};
				poNumbers.forEach(item => {
					const [orderType] = item.split(':');
					newGrandTotals[orderType] = 0;
				});
				setGrandTotalsByOrderType(newGrandTotals);
			}
		};

		fetchGrandTotals();
	}, [batchName, poNumbers]);

	// Add a new state for storing calculated totals by order type
	const [calculatedTotalsByOrderType, setCalculatedTotalsByOrderType] = useState({});

	useEffect(() => {
		const calculateTotalsByOrderType = () => {
			const newCalculatedTotals = {};
			
			Object.entries(linesData).forEach(([orderType, rows]) => {
				let total = 0;
				rows.forEach(row => {
					if (Number(row.quantity) > 0 && Number(row.unitPrice) > 0) {
						total += Number(row.quantity) * Number(row.unitPrice);
					}
				});
				newCalculatedTotals[orderType] = total;
			});
			
			setCalculatedTotalsByOrderType(newCalculatedTotals);
		};
		
		calculateTotalsByOrderType();
	}, [linesData]);

	return (
		<div>
		<svg style={{ display: 'none' }}>
				<symbol id="icon-edit" width="20" height="20" viewBox="0 0 20 20">
					<path
						d="M17.4388 4.5917L15.4083 2.56127C14.6612 1.81291 13.4403 1.81291 12.6931 2.56127L12.5941 2.46228L12.594 2.46236L2.08936 12.9682C2.08936 12.9683 2.08936 12.9683 2.08936 12.9683C1.94367 13.1139 1.86 13.3112 1.86 13.5194V17.3596C1.86 17.7907 2.20931 18.14 2.64042 18.14H6.48064C6.68805 18.14 6.88556 18.0581 7.03178 17.9119L7.03179 17.9119L17.5378 7.40593C17.9262 7.0175 18.1412 6.49858 18.1412 5.94932C18.1412 5.39881 17.9261 4.88111 17.5378 4.49271L17.4388 4.5917ZM17.4388 4.5917L17.5378 4.4927L15.5074 2.46236M17.4388 4.5917L15.5074 2.46236M15.5074 2.46236C15.5074 2.46233 15.5074 2.4623 15.5073 2.46228L15.5074 2.46236ZM16.4352 5.59505L16.4357 5.59554C16.5298 5.68867 16.5813 5.81333 16.5813 5.94821C16.5813 6.08159 16.53 6.20662 16.4353 6.30136C16.4352 6.30136 16.4352 6.30137 16.4352 6.30137L14.162 8.5746L11.4253 5.83787L13.6973 3.56462C13.6974 3.56462 13.6974 3.56461 13.6974 3.5646C13.892 3.37001 14.2088 3.36964 14.4049 3.56475C14.405 3.56478 14.405 3.56482 14.4051 3.56486L16.4352 5.59505ZM3.42089 13.8423L10.3221 6.94107L13.0588 9.67778L6.1576 16.579H3.42089V13.8423Z"
						fill="#6D727A" stroke="#6D727A" strokeWidth="0.28" />
				</symbol>
				<symbol id="icon-block" width="20" height="20" viewBox="0 0 20 20" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M15.7139 4.3281L15.7074 4.31999L15.6994 4.31338L15.6739 4.29243C14.9267 3.53591 14.0369 2.93496 13.056 2.52431C12.0735 2.113 11.0192 1.9008 9.95408 1.9C8.88898 1.89921 7.83431 2.10983 6.85121 2.51968C5.86812 2.92952 4.97616 3.53042 4.22703 4.28756C3.4779 5.04469 2.8865 5.94299 2.48713 6.93038C2.08776 7.91778 1.88835 8.97462 1.90046 10.0397C1.91257 11.1047 2.13597 12.1567 2.5577 13.1348C2.97908 14.112 3.59008 14.996 4.35535 15.7355C4.35537 15.7355 4.35539 15.7356 4.35541 15.7356L4.36078 15.7427L4.36084 15.7428C4.3656 15.7492 4.37542 15.7622 4.38964 15.7747C4.40638 15.7896 4.42386 15.8037 4.44201 15.8168C5.96251 17.2979 8.00688 18.1182 10.1297 18.0986C12.255 18.0789 14.2862 17.219 15.7796 15.7066C17.273 14.1943 18.1072 12.1523 18.1 10.0269C18.0928 7.90336 17.2462 5.86886 15.745 4.36705L15.7139 4.3281ZM10.0001 3.53341L10.0003 3.53341C11.4546 3.5302 12.8659 4.01959 14.0051 4.92002L4.96674 14.0554C4.21872 13.1283 3.741 12.0118 3.58743 10.8291C3.42913 9.60993 3.62181 8.37092 4.14286 7.25742C4.66392 6.14392 5.49173 5.20211 6.52918 4.5425C7.56662 3.88289 8.77067 3.53284 10.0001 3.53341ZM10.0003 16.4672H10C8.59256 16.468 7.22475 16.0071 6.10562 15.157L15.1202 6.04539C15.8439 6.97842 16.2985 8.09256 16.4336 9.26701C16.573 10.4786 16.3666 11.705 15.8384 12.8042C15.3101 13.9035 14.4816 14.8309 13.4485 15.479C12.4154 16.1272 11.2199 16.4698 10.0003 16.4672Z"
						fill="#6D727A" stroke="#6D727A" strokeWidth="0.2" />
				</symbol>
				<symbol id="icon-plus" width="14" height="14" viewBox="0 0 14 14" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M13.4167 6.12439H7.87558V0.583319C7.87558 0.42873 7.81399 0.28018 7.70408 0.170289C7.59418 0.0615947 7.44684 0 7.29226 0H6.70773C6.38646 0 6.1244 0.260868 6.1244 0.583325V6.1244H0.583325C0.260853 6.1244 0 6.38648 0 6.70773V7.29226C0 7.44684 0.0615941 7.59419 0.170289 7.70408C0.280192 7.81398 0.428743 7.87558 0.583319 7.87558H6.1244V13.4179V13.4167C6.1244 13.5713 6.18599 13.7198 6.29589 13.8297C6.4058 13.9384 6.55314 14 6.70772 14H7.29225C7.44684 14 7.59418 13.9384 7.70407 13.8297C7.81398 13.7198 7.87557 13.5713 7.87557 13.4167V7.87561H13.4179H13.4167C13.5713 7.87561 13.7198 7.81401 13.8297 7.70411C13.9384 7.5942 14 7.44686 14 7.29228V6.70775C14 6.55316 13.9384 6.40582 13.8297 6.29593C13.7198 6.18603 13.5712 6.12439 13.4167 6.12439Z"
						fill="currentColor" />
				</symbol>
				<symbol id="icon-close" width="18" height="18" viewBox="0 0 18 18" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M15.4407 17.8802C15.4408 17.8802 15.4408 17.8803 15.4408 17.8803C15.5739 18.0132 15.7757 18.0353 15.9317 17.9468L15.6561 17.6712C15.655 17.6702 15.6539 17.6692 15.6529 17.6681C15.6528 17.668 15.6527 17.668 15.6527 17.6679L15.4407 17.8802ZM15.4407 17.8802L15.4408 17.8802L15.4407 17.8802ZM0.331912 2.34729C0.290453 2.30573 0.289391 2.23909 0.328725 2.19625L0.332017 2.19295L2.19295 0.332021L2.19315 0.331825C2.21301 0.31192 2.23991 0.30047 2.2683 0.300011C2.29634 0.299613 2.32339 0.309992 2.34388 0.328792L2.34706 0.331978L8.78649 6.77397L8.99863 6.98618L9.2108 6.77401L15.6527 0.332115L0.331874 15.6529M0.331912 2.34729L0.331832 2.34721L0.119748 2.55938L0.331969 2.34735M0.331912 2.34729C0.331931 2.34731 0.33195 2.34733 0.331969 2.34735M0.331912 2.34729L0.331969 2.34735M0.331969 2.34735L6.77382 8.78664L6.98604 8.99877L6.77386 9.21095L0.331874 15.6529M0.331874 15.6529C0.289459 15.6953 0.289292 15.7644 0.331874 15.8071M0.331874 15.6529V15.8071M0.331874 15.8071L0.331969 15.8072M0.331874 15.8071L0.331969 15.8072M0.331969 15.8072L2.10494 17.5802H2.10516L2.19305 17.6681C2.23547 17.7106 2.30455 17.7107 2.34725 17.668L0.331969 15.8072ZM11.4382 8.99881L11.6503 8.78668L11.6503 8.78672L11.4382 8.99881ZM11.4382 8.99881L11.6503 9.21099L11.6503 9.21095L11.4382 8.99881ZM8.99881 11.4382L9.21099 11.6503L9.21094 11.6503L8.99881 11.4382ZM8.99881 11.4382L8.78668 11.6503L8.78672 11.6503L8.99881 11.4382ZM6.56173 8.99881L6.3496 9.21095L6.34964 9.21099L6.56173 8.99881ZM6.56173 8.99881L6.34956 8.78672L6.3496 8.78668L6.56173 8.99881ZM15.4407 17.88L15.4407 17.8801L15.1408 17.5802L15.4407 17.88ZM17.668 15.6529C17.7094 15.6943 17.7106 15.7609 17.6712 15.8038L15.6528 0.332021C15.6955 0.289439 15.7645 0.289605 15.8069 0.332021L15.8948 0.419889H15.895L17.6679 2.19286C17.7105 2.23552 17.7105 2.30468 17.6679 2.34735L11.2261 8.78664L11.0139 8.99877L11.226 9.21095L17.668 15.6529Z"
						fill="#0C1421" />
				</symbol>
				<symbol id="download-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M10.0174 13.9323L10.0528 13.9676L10.0881 13.9323L15.1945 8.82592L15.1946 8.82591C15.5634 8.45697 15.5634 7.85881 15.1946 7.48988L15.1945 7.48987C14.8255 7.12093 14.2273 7.12093 13.8583 7.48987L13.8937 7.52523L13.8583 7.48987L10.9975 10.3508V1.89474C10.9975 1.37298 10.5745 0.95 10.0528 0.95C9.53099 0.95 9.10801 1.37298 9.10801 1.89474V10.3508L6.24709 7.48987C5.87815 7.12091 5.27998 7.12091 4.91104 7.48987C4.54209 7.85881 4.54209 8.45698 4.91104 8.82592L10.0174 13.9323Z"
						fill="#6D727A" stroke="#6D727A" strokeWidth="0.1" />
					<path
						d="M3.8396 13.5263C3.8396 13.0046 3.41662 12.5816 2.89486 12.5816C2.3731 12.5816 1.95012 13.0046 1.95012 13.5263V14.9579C1.95012 16.6657 3.33451 18.05 5.04223 18.05H15.0633C16.771 18.05 18.1554 16.6657 18.1554 14.9579V13.5263C18.1554 13.0046 17.7323 12.5816 17.2106 12.5816C16.689 12.5816 16.2659 13.0046 16.2659 13.5263V14.9579C16.2659 15.6221 15.7275 16.1605 15.0633 16.1605H5.04223C4.37803 16.1605 3.8396 15.6221 3.8396 14.9579V13.5263Z"
						fill="#6D727A" stroke="#6D727A" strokeWidth="0.1" />
				</symbol>
				<symbol id="speed-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M18.1825 10.0423C18.0492 10.0605 17.9209 10.1049 17.8048 10.1727C17.6887 10.2406 17.5871 10.3307 17.5058 10.4378C17.4245 10.545 17.3651 10.6671 17.331 10.7972C17.297 10.9273 17.2888 11.0628 17.3072 11.1961C17.5389 12.7844 17.2276 14.4044 16.4237 15.7937C16.2872 16.0283 16.2494 16.3075 16.3187 16.5699C16.388 16.8324 16.5587 17.0565 16.7932 17.1932C16.9484 17.2843 17.1251 17.3323 17.3051 17.3324C17.4846 17.3322 17.661 17.2848 17.8164 17.195C17.9718 17.1051 18.1009 16.976 18.1907 16.8205C19.2261 15.0368 19.629 12.9558 19.3342 10.9145C19.2966 10.6464 19.1543 10.4041 18.9384 10.2406C18.7226 10.0771 18.4508 10.0058 18.1825 10.0423Z"
						fill="#6D727A" />
					<path
						d="M10.2137 5.04749C10.5003 5.04749 10.7952 5.06694 11.0695 5.09151C11.3916 5.13141 11.7112 5.18952 12.0267 5.26555C12.1591 5.30074 12.2971 5.30904 12.4327 5.28994C12.5683 5.27084 12.6986 5.22474 12.8161 5.15436C12.9335 5.08398 13.0357 4.99076 13.1165 4.8802C13.1973 4.76965 13.255 4.64402 13.2864 4.51074C13.3178 4.37746 13.3221 4.23924 13.2991 4.10426C13.2761 3.96928 13.2263 3.84029 13.1525 3.72491C13.0788 3.60954 12.9827 3.51013 12.8698 3.43256C12.757 3.355 12.6297 3.30086 12.4956 3.27334C12.0955 3.17687 11.6901 3.10406 11.2815 3.05528C10.9211 3.0215 10.5618 3 10.2137 3C7.77098 3.00298 5.42917 3.97466 3.70191 5.70192C1.97465 7.42918 1.00297 9.77099 0.999985 12.2137C0.992131 13.8313 1.41623 15.4217 2.22848 16.8206C2.3652 17.0538 2.58862 17.2234 2.84998 17.2925C3.11133 17.3616 3.38941 17.3246 3.62353 17.1894C3.85765 17.0542 4.0288 16.8319 4.09963 16.571C4.17046 16.3101 4.13522 16.0318 4.00161 15.7968C3.37017 14.7087 3.04078 13.4717 3.04747 12.2137C3.04964 10.3138 3.80535 8.49228 5.1488 7.14882C6.49226 5.80536 8.31376 5.04966 10.2137 5.04749Z"
						fill="#6D727A" />
					<path
						d="M16.056 6.37127C15.864 6.17935 15.6037 6.07153 15.3322 6.07153C15.0607 6.07153 14.8004 6.17935 14.6084 6.37127L10.7376 10.2421C10.2946 10.1189 9.82326 10.1458 9.39718 10.3188C8.97111 10.4918 8.61432 10.801 8.38252 11.1981C8.15073 11.5953 8.05698 12.058 8.11593 12.514C8.17487 12.9701 8.38319 13.3938 8.70835 13.7189C9.0335 14.0441 9.45719 14.2524 9.91324 14.3113C10.3693 14.3703 10.832 14.2765 11.2292 14.0447C11.6263 13.813 11.9355 13.4562 12.1085 13.0301C12.2814 12.604 12.3084 12.1327 12.1852 11.6896L16.056 7.81885C16.2479 7.62687 16.3557 7.36652 16.3557 7.09506C16.3557 6.8236 16.2479 6.56325 16.056 6.37127Z"
						fill="#6D727A" />
				</symbol>
				<symbol id="trash-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M8.85686 7.20209C8.85708 6.95367 8.762 6.762 8.61534 6.63331C8.47013 6.5059 8.27874 6.4439 8.08993 6.4439C7.90111 6.4439 7.70968 6.5059 7.56439 6.63329C7.41764 6.76196 7.3224 6.9536 7.3224 7.20203V15.1881C7.3224 15.4367 7.41756 15.6285 7.56424 15.7573C7.70947 15.8848 7.90084 15.9468 8.08963 15.9468C8.27842 15.9468 8.46979 15.8848 8.61502 15.7573C8.7617 15.6285 8.85686 15.4367 8.85686 15.1881V7.20209ZM8.85686 7.20209L8.78186 7.20203H8.85686V7.20209ZM4.26882 3.31495H4.26879L2.4972 3.31576C2.49718 3.31576 2.49717 3.31576 2.49716 3.31576C2.24859 3.31577 2.05682 3.41093 1.92805 3.5576C1.80054 3.70283 1.73848 3.8942 1.73848 4.08299C1.73848 4.27178 1.80054 4.46315 1.92805 4.60838C2.05683 4.75506 2.24861 4.85022 2.4972 4.85022H3.50172L3.50094 15.6307C3.50094 17.5271 5.04884 19.075 6.94519 19.075H13.0002C14.8965 19.075 16.4444 17.5263 16.4444 15.6307V4.84941H17.4498C17.6983 4.84941 17.8901 4.75425 18.0189 4.60757C18.1464 4.46234 18.2085 4.27097 18.2085 4.08218C18.2085 3.89339 18.1464 3.70202 18.0189 3.55679C17.8901 3.41011 17.6983 3.31495 17.4498 3.31495H12.8298C12.7226 2.7207 12.434 2.18796 12.0235 1.77741C10.3465 0.099754 7.52116 1.0479 7.11598 3.31495H4.26882ZM11.0885 7.20203V15.1881C11.0885 15.4367 11.1836 15.6285 11.3303 15.7573C11.4755 15.8848 11.6669 15.9468 11.8557 15.9468C12.0445 15.9468 12.2358 15.8848 12.3811 15.7573C12.5278 15.6285 12.6229 15.4367 12.6229 15.1881V7.20203C12.6229 6.95362 12.5277 6.76197 12.381 6.6333C12.2358 6.5059 12.0445 6.4439 11.8557 6.4439C11.6669 6.4439 11.4755 6.5059 11.3303 6.6333C11.1836 6.76197 11.0885 6.95362 11.0885 7.20203ZM11.2406 3.31495H8.70568C9.15882 2.18355 10.7874 2.18355 11.2406 3.31495ZM14.9101 4.8502L14.9107 15.6315C14.9107 16.6807 14.0501 17.5414 13.0009 17.5414H6.94588C5.89669 17.5414 5.03604 16.68 5.03604 15.6315V4.8502H14.9101Z"
						fill="currentColor" stroke="currentColor" strokeWidth="0.15" />
				</symbol>
				<symbol id="green-tick" width="26" height="26" viewBox="0 0 26 26" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M13 0C5.82783 0 0 5.82783 0 13C0 20.1722 5.82783 26 13 26C20.1722 26 26 20.1722 26 13C26.001 5.82783 20.1732 0 13 0ZM20.5212 9.18427L11.037 19.1063C10.818 19.3253 10.5193 19.4553 10.2196 19.4553C9.93035 19.4553 9.65158 19.3452 9.44305 19.1566L4.65185 14.7928C4.1939 14.3641 4.1635 13.6474 4.57221 13.1789C5.00083 12.7105 5.72811 12.6811 6.19551 13.0993L10.1599 16.7052L18.8569 7.59955C19.295 7.14159 20.0223 7.1311 20.4802 7.56916C20.9403 7.99883 20.9603 8.72631 20.5212 9.18427Z"
						fill="#168D2A" />
				</symbol>
				<symbol id='notes-icon' width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M4.13686 7.23764C3.66233 7.23764 3.27949 6.85394 3.27949 6.38026C3.27949 5.90658 3.66233 5.52288 4.13686 5.52288H7.58936C8.06389 5.52288 8.44673 5.90658 8.44673 6.38026C8.44673 6.85394 8.06389 7.23764 7.58936 7.23764H4.13686ZM4.13686 11.213C3.66233 11.213 3.27949 10.8293 3.27949 10.3556C3.27949 9.88193 3.66233 9.49824 4.13686 9.49824H13.2005C13.675 9.49824 14.0578 9.88193 14.0578 10.3556C14.0578 10.8293 13.675 11.213 13.2005 11.213L4.13686 11.2138V11.213ZM4.13686 15.1892C3.66233 15.1892 3.27949 14.8055 3.27949 14.3318C3.27949 13.8582 3.66233 13.4745 4.13686 13.4745H10.9943C11.4671 13.4745 11.8516 13.8582 11.8516 14.3318C11.8516 14.8055 11.4671 15.1892 10.9943 15.1892H4.13686ZM13.0629 18.2851H3.80654C2.65544 18.2851 1.71403 17.3445 1.71403 16.1926L1.71488 3.80646C1.71488 2.65536 2.65629 1.71395 3.80739 1.71395H10.0433C10.6358 1.71395 11.1027 1.90665 11.522 2.32684L15.011 5.81498C15.4304 6.23518 15.6222 6.70121 15.6222 7.29459V10.9168C15.6222 11.3905 16.0068 11.7742 16.4796 11.7742C16.9525 11.7742 17.337 11.3905 17.337 10.9168V7.29459C17.337 6.26319 16.9499 5.33197 16.2224 4.60357L12.7334 1.11544C12.0059 0.387083 11.0738 0 10.0432 0H3.80737C1.70893 0 0 1.70882 0 3.8065V16.1935C0 18.2911 1.70882 20 3.80737 20H13.0637C13.5366 20 13.9211 19.6163 13.9211 19.1426C13.9211 18.6689 13.5366 18.2852 13.0637 18.2852L13.0629 18.2851Z" fill='currentColor'/>
</symbol>
				<symbol id='info-icon' width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M6.45365 1.60134L0.320033 12.2262C-0.106678 12.9659 -0.106678 13.8489 0.320033 14.5886C0.746744 15.3284 1.51156 15.7698 2.36502 15.7698H14.6304C16.3933 15.8289 17.6114 13.7234 16.6768 12.2262L10.5432 1.60134C9.71341 0.0450835 7.28159 0.0436093 6.45187 1.60134H6.45365ZM8.50011 1.60134C8.92682 1.60134 9.30923 1.82281 9.52332 2.19194L15.6569 12.8168C15.871 13.1859 15.871 13.6289 15.6569 13.998C15.4428 14.3672 15.0604 14.5886 14.6337 14.5886H2.36839C1.94168 14.5886 1.55927 14.3686 1.34517 13.998C1.13108 13.6274 1.13108 13.186 1.34517 12.8168L7.47879 2.19194C7.69288 1.82281 8.07529 1.60134 8.502 1.60134H8.50011Z" fill="rgba(225, 62, 62, 1)" />
					<path d="M8.49873 12.8179C9.27539 12.8046 9.27539 11.65 8.49873 11.6367C7.72208 11.65 7.72208 12.8046 8.49873 12.8179Z" fill="rgba(225, 62, 62, 1)" />
					<path d="M8.50018 10.4557C8.82649 10.4557 9.09079 10.1915 9.09079 9.86514V7.50272C9.09079 7.17641 8.82649 6.91211 8.50018 6.91211C8.17387 6.91211 7.90958 7.17641 7.90958 7.50272V9.86514C7.90958 10.1915 8.17387 10.4557 8.50018 10.4557Z" fill="rgba(225, 62, 62, 1)" />
				</symbol>
				<symbol id='notes-icon' width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M3.6 14.4H10.8V12.6H3.6V14.4ZM3.6 10.8H10.8V9H3.6V10.8ZM1.8 18C1.305 18 0.88125 17.8238 0.52875 17.4713C0.17625 17.1188 0 16.695 0 16.2V1.8C0 1.305 0.17625 0.88125 0.52875 0.52875C0.88125 0.17625 1.305 0 1.8 0H9L14.4 5.4V16.2C14.4 16.695 14.2237 17.1188 13.8712 17.4713C13.5187 17.8238 13.095 18 12.6 18H1.8ZM8.1 6.3V1.8H1.8V16.2H12.6V6.3H8.1Z" fill="currentColor" />
				</symbol>
				<symbol id='arrow-back' width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="12" height="24" fill="white"/>
<path fillRule="evenodd" clip-rule="evenodd" d="M8.71992 5.84794C8.7642 5.80255 8.80406 5.75495 8.83837 5.70182C8.8738 5.64979 8.90258 5.59444 8.92693 5.53687C8.95129 5.47931 8.969 5.41842 8.98118 5.35754C8.99336 5.29554 9 5.23355 9 5.17045C9 5.13945 8.99779 5.10735 8.99557 5.07636C8.99225 5.04536 8.98782 5.01436 8.98118 4.98337C8.97565 4.95237 8.9679 4.92248 8.95904 4.89259C8.94908 4.8627 8.93911 4.83281 8.92694 4.80403C8.91476 4.77525 8.90148 4.74647 8.88709 4.71879C8.87159 4.69112 8.85609 4.66455 8.83838 4.63909C8.82066 4.61252 8.80295 4.58706 8.78303 4.56271C8.7631 4.53835 8.74207 4.5151 8.71993 4.49296C8.69778 4.47083 8.67454 4.44979 8.65018 4.42986C8.62583 4.40994 8.60037 4.39223 8.5738 4.37451C8.54834 4.3568 8.52177 4.3413 8.49409 4.3258C8.46642 4.31141 8.43764 4.29813 8.40886 4.28595C8.38007 4.27378 8.35019 4.26381 8.3203 4.25385C8.29041 4.24499 8.26052 4.23724 8.22952 4.23171C8.19852 4.22507 8.16753 4.22064 8.13653 4.21732C8.10554 4.2151 8.07343 4.21289 8.04244 4.21289C7.97934 4.21289 7.91735 4.21953 7.85535 4.23171C7.79447 4.24389 7.73469 4.2616 7.67602 4.28595C7.61845 4.31031 7.5631 4.33909 7.51107 4.37452C7.45794 4.40883 7.41033 4.44869 7.36495 4.49297L0.280074 11.5778C0.257934 11.6 0.236902 11.6232 0.216973 11.6476C0.197047 11.6719 0.179336 11.6974 0.161624 11.724C0.143912 11.7494 0.128412 11.776 0.112913 11.8037C0.0985219 11.8313 0.0852386 11.8601 0.0730628 11.8889C0.0608859 11.9177 0.0509222 11.9476 0.0409594 11.9775C0.0321033 12.0074 0.0243542 12.0373 0.0188192 12.0682C0.012177 12.0992 0.00774915 12.1302 0.00442805 12.1612C0.00221388 12.1922 0 12.2243 0 12.2553C0 12.2863 0.00221388 12.3184 0.00442805 12.3494C0.00774915 12.3804 0.012177 12.4114 0.0188192 12.4424C0.0243542 12.4734 0.0321033 12.5033 0.0409594 12.5332C0.0509225 12.5631 0.0608861 12.593 0.0730628 12.6217C0.08524 12.6505 0.0985234 12.6793 0.112913 12.707C0.128411 12.7347 0.143912 12.7612 0.161624 12.7867C0.179336 12.8133 0.197048 12.8387 0.216973 12.8631C0.236899 12.8874 0.257932 12.9107 0.280074 12.9328L7.36495 20.0177C7.41034 20.062 7.45794 20.1018 7.51107 20.1361C7.5631 20.1716 7.61845 20.2003 7.67602 20.2247C7.73469 20.2491 7.79447 20.2668 7.85535 20.2789C7.91735 20.2911 7.97934 20.2978 8.04244 20.2978C8.07344 20.2978 8.10554 20.2956 8.13653 20.2933C8.16753 20.29 8.19853 20.2856 8.22952 20.2789C8.26052 20.2734 8.29041 20.2657 8.3203 20.2568C8.35019 20.2468 8.38007 20.2369 8.40886 20.2247C8.43764 20.2125 8.46642 20.1992 8.49409 20.1849C8.52177 20.1694 8.54834 20.1539 8.5738 20.1361C8.60037 20.1184 8.62583 20.1007 8.65018 20.0808C8.67454 20.0609 8.69779 20.0398 8.71993 20.0177C8.74206 19.9956 8.7631 19.9723 8.78303 19.948C8.80295 19.9236 8.82066 19.8981 8.83838 19.8716C8.85609 19.8461 8.87159 19.8195 8.88709 19.7919C8.90148 19.7642 8.91476 19.7354 8.92694 19.7066C8.93911 19.6778 8.94908 19.648 8.95904 19.6181C8.9679 19.5882 8.97565 19.5583 8.98118 19.5273C8.98782 19.4963 8.99225 19.4653 8.99557 19.4343C8.99779 19.4033 9 19.3712 9 19.3402C9 19.2771 8.99336 19.2151 8.98118 19.1531C8.969 19.0922 8.95129 19.0325 8.92693 18.9738C8.90258 18.9162 8.8738 18.8609 8.83837 18.8088C8.80406 18.7557 8.7642 18.7081 8.71992 18.6627L2.31151 12.2554L8.71992 5.84794Z" fill="#6D727A"/>
</symbol>





			</svg>
			<Header />
			<main>
				<div className="pof2frms-container">
					<div className="pof2frms-head">
						<h1><Link to={"/orders-lisiting"}><svg width="14" height="24">
												<use href="#arrow-back"></use>
											</svg></Link> <span>Perform QA</span></h1>
						<div className='pof2frms-popup-action pof2frms-perform-qa'>
							<button type="button" className='outline' disabled={enableValidate} onClick={triggerValidateChanges}>Validate Changes</button>
							<button type="button" className="outline" onClick={() => downloadDocuments(batchName)}>Download Documents</button>
							<button type="button" className="outline" onClick={handleUpdatePONumber}>Update PO Number</button>
							<button type="button" onClick={triggerEMS}>Send to RFMS</button>
						</div>
					</div>
					<div className='ship-batch-row'>
						<div className='ship-batch-column'>
							<span>Batch Name</span>
							<div >{`${batchName}`}</div>
						</div>
						<div className="ship-batch-column">
							<span>
								Sold to{' '}
								<button to="#" onClick={toggleSoldEditable}>Edit</button>
							</span>
							<div
								ref={soldToRef} // Attach ref to the textarea
								value={soldToValue}
							>{soldToValue}</div>
						</div>
						<div className="ship-batch-column">
							<span>
								Ship to{' '}
								<button to="#" onClick={toggleShipEditable}>Edit</button>
							</span>
							<div
								ref={shipToRef} // Attach ref to the textarea
							>{shipToValue}</div>
						</div>
						
					</div>
					<p className='po2rfms-info-text'>Edit the fields by double clicking on the cells</p>
					<div className="po2frms-table ">
						<table>
							<thead>
								<tr>
									<th>Order Name</th>
									<th>PO number</th>
									<th>Number of Items</th>
									<th>Actions</th>
									<th>G. Total</th>
								</tr>
							</thead>
							<tbody>
		{loading && (
			<>
				<tr>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
				</tr>
				<tr>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
				</tr>
				<tr>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
				</tr>
				<tr>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
				</tr>
				<tr>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
				</tr>
				<tr>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
					<td>
						<div className="skeleton-box"></div>
					</td>
				</tr>
			</>
		)}
		{Object.keys(linesData).length === 0 && !loading && (
		<tr>
			<td colSpan={5}>No data available</td>
		</tr>
		)}
{!loading && Object.keys(linesData).map((key, index) => {
  const poEntry = poNumbers.find(item => item.startsWith(`${key}:`));
  const poValue = poEntry ? poEntry.split(':')[1] : "N/A";

  return (
    <React.Fragment key={index}>
      <tr className="qa-header">
        <td
          className={`po2frms-expand ${expandedRows[key] ? 'expanded' : ''}`}
          onClick={() => toggleRow(key)}
        >
          {key}
        </td>
        <td>
          <span className="batch-box">{`${key}-${poValue}`}</span>
        </td>
        <td>{linesData[key]?.length || 0}</td>
        <td>
          <div
            className={`po2frms-table-action${expandedRows[key] ? ' po2frms-show-action' : ''}`}
          >
            <span className="insertRow" onClick={() => addRow(key, linesData[key]?.length || 0)}>
              <svg width="14" height="14" fill="rgba(225, 62, 62, 1)"><use href="#icon-plus" /></svg>
              Insert Row
            </span>
            <span
              className={`addNotes ${isNotesComple ? 'disable' : ''} ${expandedRows[key] ? 'show-notes' : ''}`}
              onClick={() => toggleNotesBox(key)}
            >
              <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#notes-icon" /></svg>
              Add Work Order Notes
            </span>
          </div>
        </td>
        <td
          style={{ border: '1px solid #ccc', borderRight: '0', width: '150px' }}
          className="grand-total"
        >
          {grandTotalsByOrderType[key]?.toFixed(2) || '0.00'}
          {Math.abs(Number(grandTotalsByOrderType[key]) - Number(calculatedTotalsByOrderType[key])) > 0.01 && (
            <span
              style={{ marginLeft: '10px', verticalAlign: 'middle' }}
              className="warning-icon"
              data-tooltip={`warnings: Price mismatch - Calculated: ${calculatedTotalsByOrderType[key]?.toFixed(2)}, Expected: ${grandTotalsByOrderType[key]?.toFixed(2)}`}
            >
              <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#info-icon" /></svg>
            </span>
          )}
        </td>
      </tr>

      {expandedRows[key] && (
        <tr>
          <td colSpan={5}>
            <table>
              <thead className="po2rfms-table">
                <tr>
                  <th>Style/Item Name</th>
                  <th>Color/Description</th>
                  <th>Qty</th>
                  <th>Units</th>
                  <th>Unit Price</th>
                  <th>Total Price</th>
                  <th>Notes</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {linesData[key].length === 0 ? (
                  <tr>
                    <td colSpan="8" className="no-result-founds" style={{ textAlign: 'center' }}>
                      No data found
                    </td>
                  </tr>
                ) : (
                  linesData[key].map((row, subIndex) => (
                    <tr key={row.id || `${key}-${subIndex}`}> {/* Ensure fallback key */}
                      {/* Style Name */}
                      <td>
                        {(row.warnings?.styleName || !row.styleName || !row.productId) && (
                          <span data-tooltip={row.warnings?.styleName || (!row.styleName ? 'warnings: Could not find product' : 'warnings: No product ID found')}>
                            <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#info-icon" /></svg>
                          </span>
                        )}
                        <div className="textarea" onDoubleClick={() => handleDoubleClick(row, subIndex, 1, key)}>
                          {row.styleName || ""}
                        </div>
                      </td>
                      {/* Color/Description */}
                      <td className="color">
                        <div className="textarea" onDoubleClick={() => handleDoubleClick(row, subIndex, 2, key)} style={{ textAlign: 'center', width: '100%' }}>
                          {row.colorName?.trim?.() ? row.colorName : row.styleName?.trim?.() ? '-' : ''}
                        </div>
                      </td>
                      {/* Quantity */}
                      <td className="qty">
                        {(row.warnings?.quantity || Number(row.quantity) <= 0) && (
                          <span data-tooltip={row.warnings?.quantity || 'warnings: Quantity is zero or negative'}>
                            <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#info-icon" /></svg>
                          </span>
                        )}
                        <input
                          type="number"
                          value={row.quantity}
                          readOnly
                          onDoubleClick={handleFocus}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            const updatedRows = [...linesData[key]];
                            updatedRows[subIndex].quantity = e.target.value;
                            setLinesData({ ...linesData, [key]: updatedRows });
                            setenableValidate(false);
                          }}
                        />
                      </td>
                      {/* Unit */}
                      <td className="units">
                        {row.unit === null && (
                          <span data-tooltip="warnings: Unit is empty">
                            <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#info-icon" /></svg>
                          </span>
                        )}
                        <input
                          type="text"
                          value={row.unit || ""}
                          readOnly
                          onDoubleClick={handleFocus}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            const updatedRows = [...linesData[key]];
                            updatedRows[subIndex].unit = e.target.value;
                            setLinesData({ ...linesData, [key]: updatedRows });
                            setenableValidate(false);
                          }}
                        />
                      </td>
                      {/* Unit Price */}
                      <td className="price">
                        {Number(row.unitPrice) <= 0 && (
                          <span data-tooltip="warnings: Price is zero or negative">
                            <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#info-icon" /></svg>
                          </span>
                        )}
                        <input
                          type="number"
                          value={row.unitPrice || 0}
                          readOnly
                          onDoubleClick={handleFocus}
                          onBlur={handleBlur}
                          onChange={(e) => {
                            const updatedRows = [...linesData[key]];
                            updatedRows[subIndex].unitPrice = e.target.value;
                            setLinesData({ ...linesData, [key]: updatedRows });
                            setenableValidate(false);
                          }}
                        />
                      </td>
                      {/* Final Price */}
                      <td className="final-price">
                        {Number(row.price) <= 0 && (
                          <span data-tooltip="warnings: Final Price is zero or negative">
                            <svg width="18" height="20" fill="rgba(225, 62, 62, 1)"><use href="#info-icon" /></svg>
                          </span>
                        )}
                        <input
                          type="number"
                          value={(Number(row.quantity) > 0 && Number(row.unitPrice) > 0)
                            ? (Number(row.quantity) * Number(row.unitPrice)).toFixed(2)
                            : "0.00"
                          }
                          readOnly
                        />
                      </td>
                      {/* Notes */}
                      <td className="editable-text">
                        {linesData[key][subIndex].isEditing ? (
                          <textarea
                            autoFocus
                            value={linesData[key][subIndex].workOrderLines.notes || ''}
                            onBlur={() => {
                              const updatedRows = [...linesData[key]];
                              updatedRows[subIndex].isEditing = false;
                              setLinesData({ ...linesData, [key]: updatedRows });
                            }}
                            onChange={(e) => {
                              const updatedRows = [...linesData[key]];
                              // Store the notes as a string, not split by commas
                              updatedRows[subIndex].workOrderLines.notes = e.target.value;
                              setLinesData({ ...linesData, [key]: updatedRows });
                              setenableValidate(false);
                            }}
                          />
                        ) : (
                          <input
                            type="text"
                            readOnly
                            value={linesData[key][subIndex].workOrderLines.notes || ''}
                            onDoubleClick={() => {
                              const updatedRows = [...linesData[key]];
                              updatedRows[subIndex].isEditing = true;
                              setLinesData({ ...linesData, [key]: updatedRows });
                            }}
                          />
                        )}
                      </td>
                      {/* Delete Button */}
                      <td className="delete-btn">
                        <a href="#delete-file" data-tooltip="Delete" onClick={() => handleDeleteClick(subIndex, key)}>
                          <svg width="20" height="20"><use href="#trash-icon" /></svg>
                        </a>
                      </td>
                    </tr>
                  ))
                )}
                {rowNotesState[key] && (
                  <tr id={`notes-${key}`}>
                    <td colSpan={8} className='notearea'>
                      <div className='table-header'>
                        <span>Notes</span>
                        <span className='delete-row' onClick={() => hideSelectedNote(key)}>Delete</span>
                      </div>
                      <textarea
                        value={workOrderNotes[key] || ''}
                        onChange={(e) => handleWorkOrderNotesChange(key, e.target.value)}
                        placeholder="Enter work order notes here..."
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      )}
    </React.Fragment>
  );
})}


								</tbody>
									</table>
								</div>
							</div>
						</main>
						
						{isQASearch && (
					<div className="pof2frms-popup-wrapper pof2frms-popup-search">
						
						<div className="popup-overlay" onClick={closeSearchPopup}></div>
						<div className="pof2frms-popup-container">
						
						{showloader && (
    <>
        <div className='po2rfms-loader-overlay'></div>
        <span className="po2rfms-loader"></span>
    </>
)}

							<h3>Lookup Item</h3>
							<div className="pof2frms-popup-close" onClick={closeSearchPopup}></div>
							<div className="pof2frms-popup-row">
								<div className="pof2frms-popup-column-left">
                    <form
						id="po2rfms-qasearch"
                        className="pof2frms-popup-form"
                        onSubmit={async (e) => {
                            e.preventDefault(); // Prevent form refresh
							setshowloader(true);
                            const productDescription = e.target.elements.productSearch.value;
                            const result = await searchProducts(productDescription); // Call API
							setProducts([]);
							setSelectedProduct(null);
                            setProducts(result); // Save results to state
							// setSelectedProduct(null);
							
							setshowloader(false);
							
                        }
					}
                    >
                        <label>Keywords</label>
						<input
							type="search"
							name="productSearch"
							value={searchValue}
							onChange={handleChange}
							
						/>


                        <button type="submit">Search</button>
                    </form>

                    {/* Render Style Names Dynamically */}
					{!selectedProduct && (
					products.length > 0 && (
						<select
							className="po2rfms-anyProductSelect"
							value={productName}
							onChange={(e) => {
								setSelectedProduct(productName); 
								// Call the handleLabelClick function regardless of whether the value changes
								handleLabelClick(e, products);
								// setSelectedProduct(productName); // Update the selected product
							}}
							// value={selectedProduct || (products.length === 1 ? products[0].styleName : products[0]?.styleName || '')}
						>
							<option value="">Select Product</option>
							{products.map((product) => (
								<option key={product.id} value={product.styleName} onClick={() => handleLabelClick({ target: { value: product.id + ' | ' + product.styleName + ' | ' + product.styleNumber } }, products)}>
									{product.id + ' | ' + product.styleName + ' | ' + product.styleNumber}
								</option>
							))}
							{products.length === 0 && <option>No result found</option>}
						</select>
					)
				)}


                    
					{selectedProduct && (
						<div>
						<h3>
							{selectedProduct}
						</h3>
						<h4>
							Select Your Color
						</h4>
					{colorNames && (
						<select onChange={(e) => handleColorClick(e)} value={colorNames.length === 1 ? colorNames[0] : selectedColor}>
							{colorNames.length > 1 && (
							<option value="">Select Color</option>
							)}
							
						{colorNames.map((color,index) => (
						<option value = {color}>
							{color}
						</option>
						))}

					</select>
					)}
					
					</div>
					)}
					

                    <div className="pof2frms-popup-action">
                        <button type="button" className="pof2frms-cancel" onClick={closeSearchPopup}>
                            Cancel
                        </button>
                        {isProductSelected === false ? (
                            <button type="button" className="pof2frms-activated" disabled>
                                Choose
                            </button>
                        ) : (
                            <button type="button" className="pof2frms-activated" onClick={chooseProduct}>
                                Choose
                            </button>
                        )}
                    </div>
                </div>
                <div className="pof2frms-popup-column-right">
                    <h3>Current Values</h3>
                    <label htmlFor="style">Style/Item:</label>
                    <input type="text" readOnly id="style" value={productName || ''} />
                    <label htmlFor="color">Color/Description:</label>
                    <input type="text" readOnly id="color" value={selectedChangingRow.colorName || ''} />
                    <label htmlFor="productid">Product ID:</label>
                    <input type="text" readOnly id="productid" value={selectedChangingRow.productId || ''} />
                    <label htmlFor="colorid">Color ID:</label>
                    <input type="text" readOnly id="colorid" value={selectedChangingRow.colorId || ''} />
                </div>
            </div>
        </div>
    </div>
)}


						{isEMS && (
							<div className="pof2frms-popup-wrapper">
								<div className="popup-overlay"></div>
								<div className="pof2frms-popup-container">
									<h3>Send to RFMS</h3>
									<p>
										{isInvalid ? 'Changes are not validated.' : ''} Are you sure that you want to submit to RFMS?
									</p>
									<div className="pof2frms-popup-action">
										<button type="button" className="pof2frms-cancel" onClick={closeRMS}>
											Cancel
										</button>
										{isInvalid ? (
											<button type="button" className="pof2frms-deactivate" disabled>
												Proceed
											</button>
										) : (
											<button type="button" className="pof2frms-activated" onClick={() => {
												handlesendtorfms(shipToValue, soldToValue,batchName); 
												closeRMS(); // Close the popup after sending
											  }}>
												Send to RFMS
											</button>
										)}
									</div>
								</div>
							</div>
						)}
						{isValidating && (
							<div className="pof2frms-popup-wrapper pof2frms-popup-center">
								<div className="popup-overlay"></div>
								<div className="pof2frms-popup-container">
									<h3>Scanning the changes made...</h3>
									<div className="pof2frms-loading-bar" style={{ "--processing": `${progress}%` }}></div>
								</div>
							</div>
						)}
							{showPopup && (

								<div className="pof2frms-popup-wrapper" id="delete-file">
									<div className="popup-overlay" onClick={cancelDelete}></div>
									<div className="pof2frms-popup-container">
										<a href="/" className="pof2frms-popup-close" aria-label="close-popup" onClick={cancelDelete}></a>
										<h3>Delete Line</h3>
										<p>Are you sure that you want to delete?</p>
										<div className="pof2frms-popup-action">
											<button type="button" className="pof2frms-cancel" onClick={cancelDelete}>
												Cancel
											</button>
											<button type="button" className="pof2frms-deactivate" onClick={confirmDelete}>
												Delete
											</button>
										</div>
									</div>
								</div>
							)}
							{ShowShipping && (
								<div className="pof2frms-popup-wrapper">
									<div className="popup-overlay" onClick={cancelShiping}></div>
									<div className="pof2frms-popup-container pof2frms-popup-form">
										<h3>Edit Ship To</h3>
										<form onSubmit={handleShipToSubmit}>
											<div className="po2rfms-input-box">
												<label>First Name</label>
												<input
													type="text"
													name="firstName"
													value={ShipTo.firstName}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Last Name</label>
												<input
													type="text"
													name="lastName"
													value={ShipTo.lastName}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Address Line 1 (Street, Building Name)</label>
												<input
													type="text"
													name="address1"
													value={ShipTo.address1}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Address Line 2 (Apt number..)</label>
												<input
													type="text"
													name="address2"
													value={ShipTo.address2}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>State</label>
												<input type='text'
													name="state"
													value={ShipTo.state}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>City</label>
												<input type='text'
													name="city"
													value={ShipTo.city}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Postal Code</label>
												<input
													type="text"
													name="postalCode"
													value={ShipTo.postalCode}
													onChange={handleInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>County</label>
												<input type='text'
													name="county"
													value={ShipTo.county}
													onChange={handleInputChange}
												/>
											</div>

											<div className='pof2frms-popup-action'>
												<button type="button" className="pof2frms-cancel" onClick={cancelShiping}>Cancel</button>
												<button type="submit">Save Changes</button>
											</div>
										</form>
									</div>
								</div>
							)}

							{ShowSold && (
								<div className="pof2frms-popup-wrapper">
									<div className="popup-overlay" onClick={cancelSold}></div>
									<div className="pof2frms-popup-container pof2frms-popup-form">
										<h3>Edit Sold To</h3>
										<form onSubmit={soldSubmit}>
											<div className="po2rfms-input-box">
												<label>Customer ID</label>
												<input
													type="text"
													name="customerID"
													value={SoldTo.customerID}
													onChange={soldInputChange}
													readOnly={true}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Customer Type</label>
												<input
													type="text"
													name="customerTYpe"
													value={SoldTo.customerTYpe}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>First Name</label>
												<input
													type="text"
													name="firstName"
													value={SoldTo.firstName}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Last Name</label>
												<input
													type="text"
													name="lastName"
													value={SoldTo.lastName}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Postal Code</label>
												<input type="text"
													name="postalCode"
													value={SoldTo.postalCode}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>State</label>
												<input type='text'
													name="state"
													value={SoldTo.state}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>City</label>
												<input type='text'
													name="city"
													value={SoldTo.city}
													onChange={soldInputChange}
													disabled={!SoldTo.state}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>County</label>
												<input
													name="county"
													value={SoldTo.county}
													onChange={soldInputChange}
													disabled={!SoldTo.state}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Phone 1</label>
												<input
													type="text"
													name="phone1"
													value={SoldTo.phone1}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Email</label>
												<input
													type="email"
													name="email"
													value={SoldTo.email}
													onChange={soldInputChange}
												/>
											</div>
											<div className="po2rfms-input-box">
												<label>Salesman 1</label>
												<input
													type="text"
													name="salesman1"
													value={SoldTo.salesman1}
													onChange={soldInputChange}
												/>
											</div>
											<div className='pof2frms-popup-action'>
												<button type="button" className="pof2frms-cancel" onClick={cancelSold}>Cancel</button>
												<button type="submit" onClick={handleSoldToSubmit}>Save Changes</button>
											</div>
										</form>
									</div>
								</div>
							)}

							{/* Success Popup */}
							{showSuccessPopup && (
								<div className="pof2frms-popup-wrapper">
									<div className="popup-overlay"></div>
									<div className="pof2frms-popup-container">
										<h3>Success</h3>
										<p>{successMessage}</p>
										<div className="pof2frms-popup-action">
											<button type="button" className="pof2frms-activated" onClick={closeSuccessPopup}>
												OK
											</button>
										</div>
									</div>
								</div>
							)}

							{/* Error Popup */}
							{showErrorPopup && (
								<div className="pof2frms-popup-wrapper">
									<div className="popup-overlay"></div>
									<div className="pof2frms-popup-container">
										<h3>Error</h3>
										<p style={{color: '#d32f2f'}}>{errorMessage}</p>
										<div className="pof2frms-popup-action">
											<button type="button" className="pof2frms-activated" onClick={closeErrorPopup}>
												OK
											</button>
										</div>
									</div>
								</div>
							)}

							{/* RFMS Sending Loader */}
							{isSendingToRFMS && (
								<div className="pof2frms-popup-wrapper pof2frms-popup-center">
									<div className="popup-overlay"></div>
									<div className="pof2frms-popup-container">
										<h3>Sending to RFMS...</h3>
										<div className="pof2frms-loading-bar" style={{ "--processing": `${rfmsProgress}%` }}></div>
									</div>
								</div>
							)}

						</div>
					)
				}

				export default PerformQA;
